module.exports = __webpack_public_path__ + "static/dina_hero-50e8742b4b9205b144e9c48a59425fa7.png";